module.exports = __webpack_public_path__ + "img/web-icon.09ae34b3.svg";